import React from "react";
import { Card } from "./Card";
import { Grid, Paper } from "@mui/material";
import { spaceBetweenCardsHorizontally, spaceBetweenCardsVertically } from "../../../theme/styles";
import { colors } from "../../../theme/colors";

interface Props {
  open?: boolean;
  onClose?: () => void;
  title?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
}

const PopUpContent: React.FC<Props> = ({
  open,
  onClose,
  title,
  content,
  actions,
}) => {
  return (
    <>
      <Grid
        item
        md={3}
        xs={12}
        spacing={0}
        style={{ padding: "16px", maxWidth: "600px" }}
      >
        <Paper
          style={{
            // ...styles.card,
            color: colors.font.main,
            backgroundColor: colors.background.tertiary,
            border: `1px solid ${colors.background.tertiary}`,
            display: "flex",
            // flexDirection: "column",
            // alignItems: "center",
            borderRadius: 25,
            // fontSize: "1em",
            // padding: 0,
            height: "375px",
            justifyContent: "center",
            marginLeft: spaceBetweenCardsHorizontally,
            marginRight: spaceBetweenCardsHorizontally,
            marginBottom: spaceBetweenCardsVertically,

            padding: "16px",
          }}
        >
          <Card
            md={3}
            xs={12}
            pathName=""
            title="Adicione nossa AI no seu Discord"
            description={[
              "Você e sua comunidade não pagam nada para usar. A OP se encarrega da manutenção e seu faturamento vem das interação do sua comunidade com os anúncios exibidos",
            ]}
          ></Card>
        </Paper>
      </Grid>
    </>
  );
};

export default PopUpContent;
